export enum AuthStateEnum {
    INITIAL,
    LOGIN_DONE,
    EMAIL_VERIFY,
    LINK_TWITTER,
    SUCCESS,
    TWITTER,
    GOOGLE,
    APPLE,
}